module.exports = __webpack_public_path__ + "static/media/whale-3.3f135a74.gif";